import { Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { SearchService } from 'src/app/Services/search.service';
declare var $: any;
declare const PDFObject: any;
@Component({
  selector: 'app-newbee',
  templateUrl: './newbee.component.html',
  styleUrls: ['./newbee.component.css']
})
export class NewbeeComponent implements OnInit {
  src = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  pdfData;
  htmlstr: any;
  beelist: any;
  urlSafe: SafeResourceUrl;
  PDFObject12: any;
  progressBarShow: boolean = false;
  constructor(private httpRequestService: HttpRequestService,
    private searchService: SearchService,
    public sanitizer: DomSanitizer,
    private router: Router, private property: PropertiesService) {

  }
  @ViewChild('pdfViewer', null) public pdfViewer;
  ngOnInit() {
    this.getGridData();

  }

  getGridData() {
    this.progressBarShow = true;
    this.getData().then((list: any) => {
      this.progressBarShow = false;
      this.beelist = list.result.Table1;
      // this.beelist.forEach(element => {
      //   // element.BypassUrl=this.sanitizer.bypassSecurityTrustResourceUrl(element.ImgPath);
      //   element.styleurl = "url('" + this.sanitizer.bypassSecurityTrustResourceUrl(element.ImgPath) + "')";
      // });
      // console.log(this.beelist);
      // var html = "";
      // list.result.Table1.forEach(element => {
      //   html = html + '<div class="col-4"><div class="avatar-upload"><div class="avatar-preview">';
      //   html = html + '<div id="imagePreview" style="background-image: url(' + element.ImgPath + ');">';
      //   html = html + '<a href="' + element.DocPath + '" target="_blank"><p>' + element.FileName + '</p></a>';
      //   html = html + '</div></div></div></div>';
      // });
      // this.htmlstr = html;
    });

  }
  getData() {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + "/HR/LoadNewBee")
        .then((res: any) => {
          console.log('Response', res);
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  downloadFile(FileName) {
    this.progressBarShow = true;
    $('#dvprint').html('');
    this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + "/FileStorage/downloadFileHR?fileName=" + FileName + '&FolderName=EMS/Docs/new bee')
      .then((data: any) => {
        this.progressBarShow = false;
        if (data && data.response) {
          $('#modal-container').removeAttr('class').addClass('four');
          $('body').addClass('modal-active');
          $('#dvprint').html(data.Additional1);
          return;
          // let binaryString = window.atob(data.response);
          // let binaryLen = binaryString.length;
          // let bytes = new Uint8Array(binaryLen);
          // for (let i = 0; i < binaryLen; i++) {
          //   let ascii = binaryString.charCodeAt(i);
          //   bytes[i] = ascii;
          // }
          // let file = new Blob([bytes], { type: data.status });
          // var fileURL = URL.createObjectURL(file);
          // window.open(fileURL);
        }
      });
  }

  closepopups() {
    $('#modal-container').addClass('out');
    setTimeout(function () { $('#modal-container').removeClass('four'); }, 500);
    $('body').removeClass('modal-active');
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.closepopups();
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    //alert('');
    event.preventDefault();
  }
}
